import { computed, ref, watch } from 'vue'
import { defineStore } from 'pinia'
import type { AppLocale } from '@/i18n/messages'

export type ThemePreference = 'light' | 'dark'

function initialTheme(): ThemePreference {
  const stored = localStorage.getItem('maple-log:theme')
  if (stored === 'light' || stored === 'dark') return stored
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export const useAppStore = defineStore('app', () => {
  const locale = ref<AppLocale>(localStorage.getItem('maple-log:locale') === 'en' ? 'en' : 'zh-CN')
  const theme = ref<ThemePreference>(initialTheme())
  const presetId = ref(localStorage.getItem('maple-log:preset') ?? 'mxdc')
  const resolvedTheme = computed(() => theme.value)

  watch(locale, (value) => localStorage.setItem('maple-log:locale', value))
  watch(theme, (value) => localStorage.setItem('maple-log:theme', value))
  watch(presetId, (value) => localStorage.setItem('maple-log:preset', value))
  watch(resolvedTheme, (value) => {
    document.documentElement.dataset.theme = value
    document.documentElement.style.colorScheme = value
  }, { immediate: true })

  function toggleTheme(): void {
    theme.value = theme.value === 'light' ? 'dark' : 'light'
  }

  return { locale, theme, presetId, resolvedTheme, toggleTheme }
})
